export const homeTabId = {
  recommendation: 9998,
  normalize(value: unknown) {
    const candidate = Array.isArray(value) ? value[0] : value;

    if (typeof candidate !== 'number' && typeof candidate !== 'string') {
      return undefined;
    }

    const normalizedValue = Number(candidate);

    return Number.isFinite(normalizedValue) ? normalizedValue : undefined;
  },
};
